function azureApiRequest (data) {

	if (!window.lp.globals.enableDataCapture) {

		return Promise.reject();

	}

	// LP-72465 - Datacapture was removed
	return Promise.resolve();

}

export default azureApiRequest;
